var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"iframe",attrs:{"id":"iframe","frameborder":"0","src":_vm.url,"scrolling":"yes"},on:{"load":_vm.sendMessage}})}
var staticRenderFns = []

export { render, staticRenderFns }